export const PARAMS_NAME = {
    partnerRequests: 'Partner Requests',
    winsPercent: 'Win %'
};
export const NAN_PARAMS = {
    hour: 1,
    source: 1,
    onw: 1,
    country: 1
};


// WEBPACK FOOTER //
// ./src/scenes/BidderHourlyV2/config.js